"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Delay = /** @class */ (function () {
    function Delay(value) {
        this.hasRendered = false;
        this.value = value;
    }
    Delay.prototype.init = function (actionCallback) {
        var _this = this;
        if (this.hasRendered)
            return;
        setTimeout(function () {
            actionCallback();
            _this.hasRendered = true;
        }, this.value * 1000);
    };
    Delay.prototype.toString = function () {
        return "trigger delay for ".concat(this.value, "s");
    };
    return Delay;
}());
exports.default = Delay;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVsYXkuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90cmlnZ2Vycy9EZWxheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBS0ksZUFBYSxLQUFhO1FBRjFCLGdCQUFXLEdBQUcsS0FBSyxDQUFBO1FBR2YsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7SUFDdEIsQ0FBQztJQUVELG9CQUFJLEdBQUosVUFBTSxjQUE2QjtRQUFuQyxpQkFNQztRQUxHLElBQUksSUFBSSxDQUFDLFdBQVc7WUFBRSxPQUFNO1FBQzVCLFVBQVUsQ0FBQztZQUNQLGNBQWMsRUFBRSxDQUFBO1lBQ2hCLEtBQUksQ0FBQyxXQUFXLEdBQUcsSUFBSSxDQUFBO1FBQzNCLENBQUMsRUFBRSxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxDQUFBO0lBQ3pCLENBQUM7SUFFRCx3QkFBUSxHQUFSO1FBQ0ksT0FBTyw0QkFBcUIsSUFBSSxDQUFDLEtBQUssTUFBRyxDQUFBO0lBQzdDLENBQUM7SUFDTCxZQUFDO0FBQUQsQ0FBQyxBQXBCRCxJQW9CQyJ9